import React from 'react';

function OffCanvas({
    children,
    id,
    title
}) {

    return (
        <div className="offcanvas offcanvas-end" tabIndex="-1" id={id}>
            <div className="offcanvas-header">
                <h5 id="offcanvasRightLabel">{title}</h5>
                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
            </div>
            <div className="offcanvas-body">
                {children}
            </div>
        </div> 
    );
}

export default OffCanvas;